// src/components/auth/UserDashboard.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { User, Package, Heart, Settings, MapPin, CreditCard } from 'lucide-react';

const UserDashboard = () => {
  const [activeTab, setActiveTab] = useState('profile');

  const tabs = [
    { id: 'profile', label: 'Profile', icon: User },
    { id: 'orders', label: 'Orders', icon: Package },
    { id: 'wishlist', label: 'Wishlist', icon: Heart },
    { id: 'addresses', label: 'Addresses', icon: MapPin },
    { id: 'payment', label: 'Payment Methods', icon: CreditCard },
    { id: 'settings', label: 'Settings', icon: Settings },
  ];

  return (
    <div className="min-h-screen bg-dark-950 pt-20">
      <div className="container mx-auto px-4 max-w-6xl py-8">
        <h1 className="text-3xl font-bold text-white mb-8">My Account</h1>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="bg-dark-800/50 rounded-2xl p-6">
              <ul>
                {tabs.map(tab => (
                  <li key={tab.id}>
                    <button
                      onClick={() => setActiveTab(tab.id)}
                      className={`w-full text-left flex items-center p-3 rounded-lg mb-2 transition-colors duration-300 ${
                        activeTab === tab.id
                          ? 'bg-accent-500/20 text-accent-400'
                          : 'text-dark-300 hover:bg-dark-700/50'
                      }`}
                    >
                      <tab.icon className="h-5 w-5 mr-3" />
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="md:col-span-3">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-dark-800/50 rounded-2xl p-8"
            >
              {/* Content for each tab goes here */}
              <h2 className="text-2xl font-bold text-white mb-6">
                {tabs.find(t => t.id === activeTab).label}
              </h2>
              <p className="text-dark-300">
                Content for the {tabs.find(t => t.id === activeTab).label} section.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;